import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import InputSelect from '../../Forms/InputSelect.jsx';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import AxiosClient from '../../assets/AxiosClient.js';
import ExcelExportButton from '../../assets/ExcelExportButton.jsx';
import ConferenceDropdown from '../../Forms/ConferenceDropdown.jsx';
import Declinedrow from './Declinedrow.jsx';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader, PageToolbar } from '../../componants/Workspace';

const Declineds = () => { 
  const {LastSelectedConference} = useStateContext() ; 
  const { SetNotification } = useStateContext();
  const [Declineds, setDeclineds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [attendPerPage, setAttendPerPage] = useState(20);
  const [nameFilter, setNameFilter] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(''); 
  const [countries, setCounrtyList] = useState([]); 
  const [selectedDates, setselectedDates] = useState('');
  const [isSend, setIsSend] = useState(false);  
  const [conferenceId, setConferenceId] = useState(LastSelectedConference);
  const abortController = new AbortController(); // Create a new AbortController instance

  useEffect(() => {
    const fetchData = async () => {
      if (!conferenceId) return; // Don't fetch if conferenceId is not set

      setLoading(true); // Set loading to true while fetching data
      try {
        const response = await AxiosClient.get(`/Registeration/Declineds/${conferenceId}`, {
          signal: abortController.signal // Attach the AbortController signal
        }); 
        console.log(response.data) ;
        const { users } = await response.data;
        setDeclineds(users);
        setCounrtyList(Array.from(new Set(users.map(user => user.country))));
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error fetching data:', error);
        }
        setLoading(false); // Ensure loading is turned off in case of an error
      }
    };

    fetchData();
    
    return () => {
      abortController.abort(); // Cleanup on component unmount or if conferenceId changes
    };
  }, [conferenceId]);  // Fetch data when conferenceId changes

  const filterDeclineds = () => {
    let filteredDeclineds = Declineds;
    if (showFilter === 'Researcher') {
      filteredDeclineds = filteredDeclineds.filter(user => user.role === 'Researcher');
    } else if (showFilter === 'Guest') {
      filteredDeclineds = filteredDeclineds.filter(user => user.role === 'Guest');
    }

    // Filter by name
    if (nameFilter.trim() !== '') {
      filteredDeclineds = filteredDeclineds.filter(user =>
        user.name.toLowerCase().includes(nameFilter.trim().toLowerCase())
      );
    }

    // Filter by date
    if (selectedDates) {
      filteredDeclineds = filteredDeclineds.filter(user => user.attendance_date.includes(selectedDates));
    }

    // Filter by country
    if (selectedCountry) {
      filteredDeclineds = filteredDeclineds.filter(user =>
        user.country.toLowerCase() === selectedCountry.toLowerCase()
      );
    }

    return filteredDeclineds;
  };

  const indexOfLastAttend = currentPage * attendPerPage;
  const indexOfFirstAttend = indexOfLastAttend - attendPerPage;
  const currentAttends = filterDeclineds().slice(indexOfFirstAttend, indexOfLastAttend);
  const ExeilData = filterDeclineds(); 
  const paginate = pageNumber => setCurrentPage(pageNumber);

  const handelResend = async () => {
    const report = [];
    const confirmed = window.confirm(`Resend acceptance mail?`);
    if (!confirmed) {
      return;
    }
    setIsSend(true);
    for (const user of ExeilData) {
      try {
        const response = await AxiosClient.get(`/Tools/resend-accept-mail/${user.id}`);

        if (response.status === 200) {
          // Successful response
          report.push({ user: user.name, mail: user.email, status: "Done" });
          SetNotification('Mail has been sent to user', 'success');
        }
      } catch (error) {
        // Error occurred
        report.push({ user: user.name, mail: user.email, status: "Error" });
        SetNotification('Error occurred while sending mail to user', 'danger');
      }
    }

    // Convert report array to text format
    const reportText = report.map(entry => `${entry.user}, ${entry.mail}, ${entry.status}`).join('\n');

    // Trigger download of the report as a text file
    const blob = new Blob([reportText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'resend_report.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <PageHeader
        title="Declined registrations"
        description="Review declined attendee registrations and follow-up."
      />
      <PageToolbar
        filters={(
          <div className="workspace-registration-filters">
            <ConferenceDropdown conferenceId={conferenceId} setConferenceId={setConferenceId} />
            <input
              type="search"
              className="form-control workspace-search"
              aria-label="Search declined registrations by name"
              placeholder="Search by name"
              value={nameFilter}
              onChange={(event) => {
                setNameFilter(event.target.value);
                setCurrentPage(1);
              }}
            />
            <InputSelect title="Country" array={countries} val={selectedCountry} setval={setSelectedCountry} />
            <InputSelect
              title="Registration day"
              val={selectedDates}
              setval={setselectedDates}
              array={['2025-04-27', '2025-04-28', '2025-04-29']}
            />
            <div className="workspace-segmented" role="group" aria-label="Filter declined registrations by role">
              {[
                [null, 'All'],
                ['Researcher', 'Researchers'],
                ['Guest', 'Guests'],
              ].map(([role, label]) => (
                <button
                  key={label}
                  type="button"
                  className={`btn ${showFilter === role ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => {
                    setShowFilter(role);
                    setCurrentPage(1);
                  }}
                  aria-pressed={showFilter === role}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        )}
        actions={(
          <>
            <ExcelExportButton data={Declineds} fileName="Declineds" label="Export all" />
            <ExcelExportButton data={ExeilData} fileName="filtered" label="Export filtered" />
            {!isSend && (
              <button className="btn btn-primary" onClick={handelResend}>
                <i className="material-icons" aria-hidden="true">mail</i>
                Remind selection
              </button>
            )}
          </>
        )}
      />

      {loading ? (
        <div className="workspace-loading"><Loader label="Loading declined registrations..." /></div>
      ) : !conferenceId ? (
        <div className="workspace-empty">Select a conference to view declined registrations.</div>
      ) : (
        <>
          <DataTable>
            <thead>
              <tr>
                <th>Image</th>
                <th>Full Name</th>
                <th>Position</th>
                <th>Nationality</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentAttends.length > 0 ? currentAttends.map((user) => (
                <Declinedrow key={user.id} attendant={user} />
              )) : (
                <tr>
                  <td colSpan="6" className="workspace-empty">No declined registrations match these filters.</td>
                </tr>
              )}
            </tbody>
          </DataTable>

          {filterDeclineds().length > attendPerPage && (
            <nav className="workspace-pagination" aria-label="Declined registration pages">
              <ul className="pagination mb-0">
                {Array.from({ length: Math.ceil(filterDeclineds().length / attendPerPage) }, (_, index) => (
                  <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => paginate(index + 1)} aria-current={currentPage === index + 1 ? 'page' : undefined}>
                      {index + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </>
      )}
    </>
  );
};

export default Declineds;
